module.exports = __webpack_public_path__ + "static/media/Drampa_gaussian2.8ebf2fa2.png";